var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import SymbolIcon from '../..//img/default-symbol.svg';
import HeadShot from '../..//img/default-headshot.svg';
import HeadShotDark from '../..//img/default-headshot-dark.svg';
var defaultSrcMap = {
    symbol: SymbolIcon,
    headshot: HeadShot,
    headshotDark: HeadShotDark,
};
var SFIconImage = function (_a) {
    var _b = _a.kind, kind = _b === void 0 ? 'symbol' : _b, _c = _a.defaultSrc, defaultSrc = _c === void 0 ? '' : _c, src = _a.src, props = __rest(_a, ["kind", "defaultSrc", "src"]);
    var handleIconError = function (event) {
        event.currentTarget.src = defaultSrc || defaultSrcMap[kind];
    };
    return _jsx("img", __assign({}, props, { src: src || defaultSrc || defaultSrcMap[kind], onError: handleIconError, alt: "" }));
};
export default SFIconImage;
